// import React from 'react';
//
// const SelectOptionSearch = () => {
//   return (
//     <div>
//
//     </div>
//   );
// };
//
// export default SelectOptionSearch;
import React, {useEffect, useState} from "react";
import "./SelectOptionSearch.css"

const SelectOptionSearch = (props) => {
    let {options, onSelect, defaultValue, emptyInputAfterSubmit} = props;
    if (emptyInputAfterSubmit === undefined) {
      emptyInputAfterSubmit = false
    }

    defaultValue = typeof (defaultValue) !== 'string' ? defaultValue.toString() : defaultValue;


    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState(defaultValue);
    const [selectedOption, setSelectedOption] = useState(null);
    const [filteredOptions, setFilteredOptions] = useState(options);
    const [focusedOptionIndex, setFocusedOptionIndex] = useState(-1);


    const randomStringClass = "Katy" + Math.floor(Math.random() * 101500000) + "Perry";


    const handleScrollWhenPressDown = (focusedIndex: number) => {

      const ul = document.querySelector('.' + randomStringClass + ' .options-container  ul');
      const ul__Height = ul ? ul.clientHeight : null;
      let li__Height = ul ? document.querySelector('.' + randomStringClass + ' .options-container ul li').clientHeight : null
      if (ul) {
        const alpha = 4;
        let scrollTo = (focusedIndex - alpha) * li__Height
        scrollTo = ul.scrollTop + li__Height

        let condition1 = true, condition2 = true, condition3 = true
        condition1 = focusedIndex * (li__Height + 4) > (ul__Height) + ul.scrollTop

        if (condition1) {
          // ul.scrollTo(0, focusedOptionIndex * li__Height)
          ul.scrollTo(0, scrollTo)
        } else {
          // ul.scrollTo(0, focusedIndex * li__Height)
        }

      }
    }
    const handleScrollWhenPressUp = (focusedIndex: number) => {

      const ul = document.querySelector('.' + randomStringClass + ' .options-container  ul');
      const ul__Height = ul ? ul.clientHeight : null;
      let li__Height = ul ? document.querySelector('.' + randomStringClass + ' .options-container ul li').clientHeight : null

      if (ul) {


        const alpha = 4;
        let scrollTo = ul.scrollTop - (li__Height)
        scrollTo = li__Height * focusedOptionIndex + (-2 * li__Height)

        scrollTo = ul.scrollTop - li__Height

        const condition1 = focusedIndex * li__Height < ul.scrollTop
        // let condition2 = (ul.scrollTop + (alpha * li__Height)) < scrollTo
        // let condition3 = (ul.scrollTop - (alpha * li__Height)) > scrollTo
        // condition2 = true
        // condition3 = true
        if (condition1) {
          ul.scrollTo(0, scrollTo)
        } else {
          // ul.scrollTo(0, focusedIndex * li__Height)
        }
      }
    }

    const onKeyDownHandler = (event) => {

      // debugger
      if (event.key === 'Tab' || (event.shiftKey && event.key === 'Tab')) {
        setIsOpen(false)
        return;
      }

      const isFocused = document.activeElement.classList.contains(randomStringClass);
      if (isFocused && (event.key === "ArrowDown" || event.key === "ArrowUp") && isOpen === false) {
        setIsOpen(true)
        return
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();


        const newIndex = focusedOptionIndex < filteredOptions.length - 1 ? focusedOptionIndex + 1 : focusedOptionIndex
        handleScrollWhenPressDown(newIndex);
        setFocusedOptionIndex(newIndex);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        const newTemp = focusedOptionIndex > 0 ? focusedOptionIndex - 1 : focusedOptionIndex
        handleScrollWhenPressUp(newTemp);
        setFocusedOptionIndex(newTemp);
        // setFocusedOptionIndex((prevIndex) =>
        //   prevIndex > 0 ? prevIndex - 1 : prevIndex
        // );
      } else if (event.key === "Enter") {
        event.preventDefault();

        if (isOpen) {
          const selectedOption = filteredOptions[focusedOptionIndex];
          if (selectedOption) {
            setSelectedOption(selectedOption);
            setIsOpen(false);
            setSearchTerm(selectedOption.label);
            onSelect(event, selectedOption);
            setFocusedOptionIndex(-1);
            if (emptyInputAfterSubmit) {
              setSearchTerm('')
            }
          }
        }

      }
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (!event.target.classList.contains(randomStringClass)) {
          setIsOpen(false);
        }
      };
      document.addEventListener('click', handleClickOutside);

      document.addEventListener("keydown", onKeyDownHandler);

      // Cleanup the event listener when the component is unmounted
      return () => {
        document.removeEventListener('click', handleClickOutside);
        document.removeEventListener("keydown", onKeyDownHandler);

      };


    }, [randomStringClass, focusedOptionIndex]);


    useEffect(() => {


      if (defaultValue !== undefined && defaultValue !== "") {
        // const temp = options.filter((option) => (option.value === defaultValue).label);
        const temp = options.filter((v, index) => {
          return v.value === defaultValue
        });

        setSearchTerm(temp.length !== 0 ? temp[0].label : "");


        setIsOpen(false)
        // setSearchTerm('')
        setFilteredOptions(options);
        // setSearchTerm(temp);
      } else {
        // setIsOpen(false)
        setSearchTerm('')
        setFilteredOptions(options);
      }

    }, [defaultValue, options]);

    const filter = (inputText) => {
      // if (inputText !== "") {

      const temp = options.filter((option) => option.label.toLowerCase().includes(inputText.toLowerCase()));

      // setFilteredOptions(temp);
      // }
      return temp;
    }

    const inputOnchange = (event) => {
      const value = event.target.value;
      setSearchTerm(value);
      setFilteredOptions([...filter(value)])
      setIsOpen(true)
    }
    const onClickInputHandler = () => {
      setIsOpen(!isOpen)

    }
    const onClickOneOfOptionsHandler = (event, v, index) => {
      setIsOpen(false);
      setSearchTerm(v.label);
      onSelect(event, v);
      setFocusedOptionIndex(index);
      if (emptyInputAfterSubmit) {
        setSearchTerm('')
      }

    }
    const removeHandler = () => {
      setIsOpen(false)
      setSearchTerm('')
      setFilteredOptions(options);
      if (props.revomeHandler !== undefined)
        props.revomeHandler()
    }
    useEffect(() => {
      const optionsContainer = document.querySelector('.options-container ul');

      const handleScroll = () => {
        const activeOption = optionsContainer.querySelector('.focused');

        if (activeOption) {
          const containerTop = optionsContainer.offsetTop;
          const containerBottom = containerTop + optionsContainer.offsetHeight;
          const optionTop = activeOption.offsetTop;
          const optionBottom = optionTop + activeOption.offsetHeight;

          if (optionTop < containerTop) {
            optionsContainer.scrollTop = optionTop;
          } else if (optionBottom > containerBottom) {
            optionsContainer.scrollTop = optionBottom - optionsContainer.offsetHeight;
          }
        }
      };

      optionsContainer && optionsContainer.addEventListener('scroll', handleScroll);

      return () => {
        optionsContainer && optionsContainer.removeEventListener('scroll', handleScroll);
      };
    }, [selectedOption, filteredOptions]);


    return (
      <>
        <div>
          <div className={"custom-select" + " " + randomStringClass}>
            {/*<div*/}
            {/*  className="selected-option"*/}
            {/*  onClick={() => setIsOpen(!isOpen)}*/}
            {/*>*/}
            {/*  {selectedOption ? selectedOption.label : "یک مورد را انتخاب کنید."}*/}
            {/*</div>*/}
            <div style={{position: "relative"}}>
              <input
                className={" " + randomStringClass + " " + `selected-option ${props.classNameInput}`}
                onClick={() => onClickInputHandler()}
                type="text"
                placeholder="انتخاب کنید..."
                value={searchTerm}
                onChange={inputOnchange}
                name={"thisIsRandomGenerated"}
                onFocus={e => e.target.setAttribute('autocomplete', 'off')}
              />
              <div
                className={"removeHandler"}
                onClick={() => removeHandler()}> &#x2716;</div>
            </div>


            {isOpen && (
              <div className="options-container">
                {/*<input*/}
                {/*  type="text"*/}
                {/*  placeholder="جستجو..."*/}
                {/*  value={searchTerm}*/}
                {/*  onChange={(e) => setSearchTerm(e.target.value)}*/}
                {/*/>*/}
                <ul>
                  {filteredOptions.map((v, index) => (
                    <li
                      key={index}
                      onClick={(event) => onClickOneOfOptionsHandler(event, v, index)}
                      className={focusedOptionIndex === index ? "focused" : ""}
                    >
                      {v.label}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
;


export default SelectOptionSearch;